import React from 'react';
import NeuralNetworkBackground from './NeuralNetworkBackground';

export default function SectionWithNeuralBg({
  as: Tag = 'section',
  id,
  className = '',
  overlayClassName = 'bg-gray-900/72',
  children,
}) {
  return (
    <Tag id={id} className={`relative overflow-hidden ${className}`}>
      <NeuralNetworkBackground />
      <div
        className={`absolute inset-0 z-[1] pointer-events-none ${overlayClassName}`}
        aria-hidden="true"
      />
      <div className="relative z-10 w-full">{children}</div>
    </Tag>
  );
}
